import { MapTile } from "web/components/Tiles"
import useTileSettingsModal from "web/hooks/data/useTileSettingsModal"
import { TileMapSettingsModal } from "../TileMapSettingsModal"

export default function MapTileWrapper({
  canEdit,
  isTemplate,
  tileHeight,
  tileFetchParams,
  overview,
  subjectType,
}) {
  const tileSettingsModal = useTileSettingsModal({
    isTemplate,
    overview,
    tileSettingsComponent: TileMapSettingsModal,
    tileTitle: "Map Settings",
    tileFetchParams,
  })

  return (
    <MapTile
      canEdit={canEdit}
      tileHeight={tileHeight}
      tileSettingsModal={tileSettingsModal}
      overview={overview}
      tileFetchParams={tileFetchParams}
      isTemplate={isTemplate}
      subjectType={subjectType}
    />
  )
}
